import { createContext } from 'react';

export type INavMenuContext = {
  dim?: boolean;
};

export const NavMenuContext = createContext<INavMenuContext | undefined>(
  undefined,
);
